import { useGridApiRef } from "@mui/x-data-grid-premium";

// Components
import CommonToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";

export default function OemMitsubishiEmployees(props) {
	const apiRef = useGridApiRef();

	return (
		<DataSmartTable
			apiRef={apiRef}
			columns={props.columns || []}
			rows={props.data || []}
			headerHeight={40}
			rowHeight={25}
			enableCustomScrollbars
			hideFooter
			disableColumnMenu
			disableRowSelectionOnClick
			disableMultipleRowSelection
			checkboxSelection={false}
			columnVisibilityModel={{
				_id: false,
				Rank: false,
				referenceType: false,
			}}
			slots={{
				toolbar: CommonToolbar,
				noRowsOverlay: NoRowsOverlay,
			}}
			slotProps={{
				toolbar: {
					filter: {
						hide: false,
					},
					search: {
						data: props.data || [],
						hide: false,
						disabled: false,
					},
				},
				noRowsOverlay: {
					title: "No Employees Metrics data",
				},
			}}
			customProps={{
				tableContainerStyle: { height: "100%", width: "100%" },
				tableClassName: {
					"functional-table": true,
				},
				hide: false,
			}}
		/>
	);
}
